export default {
  methods: {
    updateUrl(paramType, param) {
      const currentQueryParams = this.$route.query;
      const historyState = Object.assign({},
        { name: this.$route.name },
        { query: Object.assign({}, currentQueryParams, { [paramType]: param }) });

      this.$router.push(historyState);
    },
    removeQuery(params) {
      const currentQueryParams = this.$route.query;
      const historyState = Object.assign({},
        { name: this.$route.name },
        { query: Object.assign({}, currentQueryParams) },
      );

      params.forEach((item) => {
        if (typeof historyState.query[item] !== 'undefined') {
          delete historyState.query[item];
        }
      });

      this.$router.push(historyState);
    },
  },
};



// WEBPACK FOOTER //
// ./app/javascript/packs/shared/mixins/url_modification.js